import { PageHeader } from '@repo/ui/components/page-header';
import { PeriodSelector } from '@repo/ui/components/period-selector';
import type { PortfolioPeriod } from '../utils/period';

const PORTFOLIO_PERIODS = ['1W', '1M', '3M', '6M', 'YTD', '1Y'] as const;

interface PortfolioHeaderProps {
  period: PortfolioPeriod;
  onPeriodChange: (period: PortfolioPeriod) => void;
}

/**
 * Portfolio page header (PO2, node 1787:646): the period control scopes
 * return, benchmark, profit and fees, and attribution; point-in-time facts
 * like holdings stay live regardless of period. Drawdown and the risk
 * figures live on Risk & liquidity, which has its own period control.
 */
export function PortfolioHeader({
  period,
  onPeriodChange
}: PortfolioHeaderProps) {
  return (
    <PageHeader
      title="Portfolio"
      description="Choose a period to update return, benchmark, fees, and attribution."
      action={
        <PeriodSelector
          value={period}
          onChange={(nextPeriod) =>
            onPeriodChange(nextPeriod as PortfolioPeriod)
          }
          options={PORTFOLIO_PERIODS}
          aria-label="Portfolio performance period"
        />
      }
    />
  );
}
